import React, { useState } from 'react';

export const LedgerAuditor: React.FC = () => {
  const [entries] = useState([
    { id: 'tx_01', type: 'GRANT', account: 'tenant_primary', amount: '+1,000 HXN', ref: 'BETA_SIGNUP_GRANT', time: 'Just now' },
    { id: 'tx_02', type: 'LICENSE_ACTIVATE', account: 'tenant_primary', amount: '0 HXN', ref: '3MO_UNLIMITED_PASS', time: '1 hr ago' },
  ]);

  return (
    <div className="space-y-4">
      <div className="bg-neutral-900/80 border border-neutral-800 rounded-xl p-4">
        <div className="flex items-center justify-between mb-3">
          <div>
            <div className="text-xs font-semibold text-neutral-200">Append-Only Postgres Ledger</div>
            <div className="text-[10px] text-neutral-400">Strict double-entry ledger with row-level locks</div>
          </div>
          <span className="px-2 py-0.5 rounded bg-cyan-950 border border-cyan-500/40 text-cyan-300 text-[10px] font-mono">
            Balance: 1,000 HXN
          </span>
        </div>

        <table className="w-full text-left text-xs font-mono">
          <thead>
            <tr className="text-neutral-500 border-b border-neutral-800">
              <th className="pb-2">TX ID</th>
              <th className="pb-2">Operation</th>
              <th className="pb-2">Delta</th>
              <th className="pb-2">Reference</th>
              <th className="pb-2 text-right">Age</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-neutral-800/60 text-neutral-300">
            {entries.map((tx) => (
              <tr key={tx.id} className="hover:bg-neutral-800/40">
                <td className="py-2 text-cyan-400">{tx.id}</td>
                <td className="py-2">{tx.type}</td>
                <td className="py-2 text-emerald-400 font-bold">{tx.amount}</td>
                <td className="py-2 text-neutral-400">{tx.ref}</td>
                <td className="py-2 text-right text-neutral-500">{tx.time}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
